export const showConditionalField = (
  condition = { rule: '', applyToSlugName: '' },
  conditionalFields = {}
) => {
  const { applyToSlugName, rule } = condition;
  const ruleRegex = new RegExp(rule);
  const matchString = conditionalFields[applyToSlugName];
  return ruleRegex.test(matchString);
};

export const showField = ({
  isPreviewMode = false,
  condition = undefined,
  conditionalFields = {},
  show = true,
}) => {
  if (isPreviewMode && !show) return false;
  if (isPreviewMode && show && condition)
    return showConditionalField(condition, conditionalFields);
  if (isPreviewMode && show) return true;
  if (!isPreviewMode && !condition) return true;
  return false;
};

export function secondsToString(seconds) {
  let numhours = Math.floor(((seconds % 31536000) % 86400) / 3600);
  let numminutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60);
  let numseconds = ((((seconds % 31536000) % 86400) % 3600) % 60).toFixed(0);

  let string = '';
  if (numhours > 0)
    string = string + ` ${numhours} hr${numhours > 1 ? 's' : ''}`;
  if (numminutes > 0)
    string = string + ` ${numminutes} min${numminutes > 1 ? 's' : ''}`;
  if (numseconds >= 0) string = string + ` ${numseconds} s`;

  return string;
}

export async function copyTextToClipboard(
  text,
  onSuccess = () => {},
  onError = () => {}
) {
  try {
    await navigator.clipboard.writeText(text);
    console.log('Text copied to clipboard');
    onSuccess({ value: text, message: 'Text copied to clipboard' });
  } catch (err) {
    console.error('Failed to copy text: ', err);
    onError({ err, message: 'Failed to copy text' });
  }
}

export function exportJsonToTxt(jsonData) {
  const prettyString = JSON.stringify(jsonData, null, 4);
  const blob = new Blob([prettyString], { type: 'text/plain' });

  return {
    blob,
    link: URL.createObjectURL(blob),
  };
}

export const triggerDownload = (url, fileName) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName; // Suggests the filename for saving
  document.body.appendChild(a);
  a.click(); // Simulate click to start download
  document.body.removeChild(a);
};
